
import { timeFormat } from "@/utils/time";
import dict from "@/config"

const classMap = {
	INITIALIZED: "warning-color",
	FINISHED: "success-color",
	SENT: "primary-color",
	SKIPPED: "info-color"
}

export const getKlassTaskColumns = () => {
	return [
		{
			title: "班级名称",
			dataIndex: "klass",
			align: "center",
			customRender: (value = {}) => {
				return value.name || "--";
			},
		},
		{
			title: "老师",
			dataIndex: "teacher",
			align: "center",
			scopedSlots: { customRender: "teacher" },
		},
		{
			title: "待评估",
			dataIndex: "to_students",
			align: "center",
			width: 80,
			customRender: (text = [], record) => {
				const { students_initialized, students_finished, students_sent, students_skipped } = record;
				return text.length - students_initialized.length - students_finished.length - students_sent.length - students_skipped.length;
			},
		},
		{
			title: "评估中",
			dataIndex: "students_initialized",
			align: "center",
			width: 80,
			customRender: (text = []) => {
				return text.length;
			},
		},
		{
			title: "待发送",
			dataIndex: "students_finished",
			align: "center",
			width: 80,
			customRender: (text = []) => {
				return text.length;
			},
		},
		{
			title: "已发送",
			dataIndex: "students_sent",
			align: "center",
			width: 80,
			customRender: (text = []) => {
				return text.length;
			},
		},
		{
			title: "已跳过",
			dataIndex: "students_skipped",
			align: "center",
			width: 80,
			customRender: (text = []) => {
				return text.length;
			},
		},
		{
			title: "开始时间",
			dataIndex: "create_time",
			align: "center",
			width: 120,
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			width: 120,
			scopedSlots: { customRender: "operation" },
		},
	];
};

export const getAssessmentColumns = () => {
	return [
		{
			title: "学生姓名",
			dataIndex: "student",
			align: "center",
			customRender: (value = {}) => {
				return value.kid_name || "--";
			},
		},
		{
			title: "评估状态",
			dataIndex: "status",
			align: "center",
			customCell: (record) => {
				return { class: classMap[record.status] || "del-color"};
			},
			customRender: (text) => {
				return `● ${dict.ASSESSMENT_STATUS[text] || "待评估"}`;
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};

export default {
	getAssessmentColumns
};
